// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'forward-all';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.824 3.96H3.96A3.38 3.38 0 0 0 .576 7.344v9.648' />
    <path d='m10.44.576 3.384 3.384-3.384 3.384' />
    <path d='m13.824.576 3.384 3.384-3.384 3.384' />
  </g>
);

export const viewBox = '0 0 18 18';
